module.exports = __webpack_public_path__ + "media/hyper/fonts/unicons-b5ae9656e5aa1bf09839a1e030d0c827.woff2";